import React, { useEffect, useRef, useState } from "react";
import banner from "../img/banner.png";
import Header from "../components/Header";
import Footer from "../components/Footer";
import videoThumbnail from "../img/student.png";
import schoolKids from "../img/child.png";
import Review from "../components/Review";
import Protect from "../components/Protect";
import { useNavigate } from "react-router-dom";
import slide1 from "../img/slide1.jpeg";
import slide2 from "../img/slide2.jpeg";
import slide3 from "../img/slide3.jpeg";
import slide4 from "../img/slide4.jpeg";
import slide5 from "../img/slide5.jpeg";
import Package from "../components/Package";
import popup from "../img/popup.png";
import protectTraining from "../img/protect_training.jpg";

import { Swiper, SwiperSlide } from "swiper/react";

import { Autoplay } from "swiper/modules";
import Modal from "../components/Modal";
import PromoPopup from "../components/PromoPupup";

const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

const formatCurrency = (value) => currencyFormatter.format(Number(value) || 0);

const createScheduleSummary = (total) => {
  const totalCents = Math.round(total * 100);
  const recurringCents = Math.floor(totalCents / 12);
  const firstPaymentCents = totalCents - recurringCents * 11;

  return {
    first: formatCurrency(firstPaymentCents / 100),
    recurring: formatCurrency(recurringCents / 100),
  };
};

const SCHOOL_INSTALLMENTS = createScheduleSummary(9000);
const INDIVIDUAL_INSTALLMENTS = createScheduleSummary(900);

const reviews = [
  {
    text: "AngelWatch is the most realistic, engaging, and effective safety training we’ve ever had. Every school should be using this program.",
    name: "James Carter",
    work: "Officer",
  },
  {
    text: "This training was eye-opening. I learned more in a few hours than I did in years of traditional emergency training.",
    name: "Lisa Mendoza",
    work: "Daycare Owner, Director",
  },
  {
    text: "Every educator should take this course. It gave me practical tools that I can use in my classroom immediately.",
    name: "Rachel Collins",
    work: "High School Teacher",
  }
];

export default function Home() {
  const navigation = useNavigate();
  const reviewRef = useRef(null);
  const slides = [slide1, slide2, slide3, slide4, slide5];
  const [isOpen, setIsOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const handleShowPopup = () => {
    // Check if popup was previously closed in this session
    const popupClosed = sessionStorage.getItem('popupClosed');
    if (popupClosed) {
      return; // Don't show popup if it was already closed
    }

    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 5000); // Changed from 60 seconds to 5 seconds

    return () => clearTimeout(timer);
  }

  const handleClosePopup = () => {
    setShowPopup(false);
    // Mark popup as closed in session storage
    sessionStorage.setItem('popupClosed', 'true');
  }

  useEffect(() => {
    handleShowPopup();
  }, []);

  const handleGoToContactUs = () => {
    window.location.replace("/contactUs");
  }

  const smoothScrollTo = (element, duration = 1000, offset = 0) => {
    const targetY =
      element.getBoundingClientRect().top + window.scrollY - offset;
    const startY = window.scrollY;
    const distance = targetY - startY;
    let startTime = null;

    const easeInOutCubic = (t) =>
      t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

    const animation = (currentTime) => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = easeInOutCubic(progress);

      window.scrollTo(0, startY + distance * ease);

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    };

    requestAnimationFrame(animation);
  };

  const scrollToReview = () => {
    if (reviewRef.current) {
      smoothScrollTo(reviewRef.current, 1100, 100); // 80 = offset for fixed header
    }
  };

  const features = [
    {
      title: "Complete Emergency Management System",
      subtitle: "with built-in compliance support",
    },
    {
      title: "Unlimited staff training and recertification",
      subtitle: "for a full year",
    },
    {
      title: "Real-world, interactive",
      subtitle: "scenario-based testing",
    },
    {
      title: "Free Emergency Protocol Handbook",
      subtitle: "written to meet state standards",
    },
    {
      title: "Pre-written, plug-and-play SOPs",
      subtitle: "to instantly meet state inspection requirements",
    },
    {
      title: "Full staff tracking dashboard",
      subtitle: "with certification monitoring",
    },
    {
      title: "No hidden fees, per-user licenses",
      subtitle: "or surprise charges",
    },
  ];

  return (
    <div className="text-white">
      <Header />

      {/* Hero Banner Section */}
      <div
        className="bg-cover bg-cover bg-no-repeat w-full min-h-[500px] md:min-h-[500px] lg:min-h-[600px]"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 flex items-center">
          <div className="max-w-4xl mt-8 md:mt-16 lg:mt-24">
            <h1 className="text-3xl sm:text-4xl -mt-14  md:text-5xl lg:text-6xl font-bold leading-tight mb-4">
              <span className="block">
                The Only National Emergency
              </span>
              <span className="text-yellow-400 ">Certification Program</span>
            </h1>
            <p className="text-xl sm:text-2xl md:text-3xl text-[#2FB57C] font-semibold mb-2">
              Partnered With
            </p>
            <p className="text-lg sm:text-2xl mb-6">
              The American Red Cross, The American Heart Association, and Backed By The Department Of Homeland Security
            </p>
            <a href="/getCertified">
              <button
                style={{ width: "250px" }}
                className="bg-[#F0AA00]  text-white text-lg sm:text-xl py-2 px-6 rounded-full hover:bg-yellow-500 transition w-full sm:w-auto"
              >
                Get Certified Now
              </button>
            </a>
          </div>
        </div>
      </div>

      {/* Prepare Protect Prevent Section */}
      <div className="container  mx-auto px-4  sm:px-6 lg:px-8 py-8 md:py-12 relative">
        <div className="bg-[#2FB57C] -mt-24 border-4 border-white rounded-lg flex flex-col md:flex-row items-center justify-between p-6 md:p-8 lg:p-10">
          <div className="text-center md:text-left mb-6 md:mb-0 md:mr-6">
            <h2 className="text-2xl sm:text-3xl md:text-4xl  lg:text-5xl font-bold leading-tight">
              Prepare. Protect. Prevent
            </h2>
            <p className="text-lg sm:text-xl md:text-2xl mt-2">
              The Only Emergency Training That Has Saved Lives
            </p>
          </div>
          <button
            onClick={scrollToReview}
            className="bg-[#F0AA00] w-[250px] text-white lg:text-lg  py-2 px-6 rounded-full hover:bg-yellow-500 transition  "
          >
            Contact us
          </button>
          <div className="absolute bottom-[200px] z-10 right-0">
            <a href="/contactUs">
              <img
                src={popup}
                alt="popup"
                className="w-40 sm:w-56  lg:w-65"
              />
            </a>
          </div>
        </div>
      </div>
      <div className="max-w-5xl mx-auto bg-[#F0AA00] p-4 lg:p-10 mt-4 mb-4 text-center text-white text-2xl sm:text-3xl md:text-4xl  font-semibold relative">
        Over 100,000 teachers in over 10,000 schools and daycares have been
        certified
      </div>

      {/* Video and Warning Section */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-16 xl:gap-24">
          <div className="w-full lg:w-1/2 relative">
            <iframe
              className="w-full h-[350px] md:h-[450px] rounded-tl-[50px] rounded-br-[50px] md:rounded-tl-[100px] md:rounded-br-[100px] shadow-lg"
              src="https://www.youtube.com/embed/A8bYPfgZSL4"
              title="AngelWatch Emergency Training"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>

          <div className="w-full lg:w-1/2 relative">
            <div className="absolute -top-[165px] lg:-top-[275px] z-10 right-2 lg:-right-[50px] 2xl:right-[-250px]">
              <a href="/contactUs">
                <img
                  src={popup}
                  alt="popup"
                  className="w-35 sm:w-40  lg:w-65"
                />
              </a>
            </div>
            <p className="text-gray-700 mb-10 text-base sm:text-lg md:text-xl leading-relaxed">
              Schools and childcare centers are required to meet emergency, safety, and certification mandates without being given a system to manage them, and when training lapses, deadlines are missed, or an incident occurs, the liability falls entirely on the center, not the state. AngelWatch closes that gap by providing one centralized Emergency Certification and Management System that includes interactive, scenario-based emergency training videos; the ability to upload, store, and manage all state-required and center-required certifications in one place; real-time staff training and compliance tracking; documented proof of completion for audits, licensing, and inspections; automated reminders and alerts sent to staff and administration for what is required and when; and a complete management dashboard that keeps emergency readiness, certifications, and accountability organized, current, and defensible at all times.
            </p>
          </div>
        </div>
      </div>

      {/* Certification Details Section */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-16 xl:gap-24">
          <div className="w-full lg:w-1/2 order-2 lg:order-1">
            <p className="text-pink-600 font-medium text-sm sm:text-base md:text-lg">
              Interactive. On-Demand. Backed by the U.S. Government. Now
              Available to You.
            </p>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 leading-tight mt-4">
              The Only National Accredited Emergency Certification and
              Management System for Schools and Daycares
            </h2>
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed mt-4">
              97% of schools and daycares fail their emergency protocol audits
              due to outdated or incomplete safety guidelines. AngelWatch was
              built specifically to address this alarming failure. The result?
              Real tools — not just ideas or access. Most centers are given
              vague requirements without clear guidance. AngelWatch delivers a
              complete, ready-to-implement solution that provides clarity,
              structure, and real protection.
            </p>
            <button
              onClick={() => navigation("/getCertified")}
              className="bg-[#F0AA00] w-[250px] text-white font-semibold py-3 px-8 rounded-full hover:bg-yellow-600 transition mt-6 w-full sm:w-auto"
            >
              Protect Your School Now →
            </button>
          </div>

          <div className="w-full lg:w-1/2 order-1 lg:order-2">
            <img
              src={schoolKids}
              alt="Kids learning"
              className="rounded-tl-[50px] rounded-br-[50px] md:rounded-tl-[100px] md:rounded-br-[100px] shadow-lg w-full"
            />
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto">
        <Protect />
      </div>

      {/* Why Trust Section */}
      <div className="bg-white  ">
        <div className=" ">
          <div className="container mx-auto">
            <h2 className="text-2xl sm:text-3xl p-4 md:text-4xl font-bold text-center text-black">
              Why Schools and Daycares Trust AngelWatch
            </h2>
            <p className="text-black p-2 text-center text-base sm:text-lg md:text-xl mt-4 max-w-3xl mx-auto">
              Thousands of Schools and Child Care Centers Rely on AngelWatch to
              Protect Students and Meet State Compliance Standards.
            </p>
          </div>
          {/* <div className="bg-[#FCF7EE] lg:mb-10 border-b-2 mt-10 border-[#F0AA00] p-10">
            <div className="relative mt-8  container mx-auto md:mt-12 h-[300px] mb-8  w-full aspect-video rounded-md overflow-hidden shadow-lg">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/S5-xkLTXp6E?si=ldTwC-u5u9HTMAZR"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div> */}
        </div>
      </div>

      {/* Features Grid Section */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 ">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-4 bg-[#FCF7EE] rounded-r-md border-l-4 border-[#F0AA00]"
            >
              <h3 className="font-semibold text-gray-900 text-base sm:text-lg">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm sm:text-base mt-1">
                {feature.subtitle}
              </p>
            </div>
          ))}
        </div>
        <div className="container mt-24 mx-auto">
          <Swiper
            spaceBetween={20}
            slidesPerView={1}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              reverseDirection: true,
            }}
            modules={[Autoplay]}
            breakpoints={{
              640: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 4 },
            }}
            dir="ltr"
            className="mb-10"
          >
            {slides.map((imgSrc, idx) => (
              <SwiperSlide key={idx}>
                <div className="w-80 mx-auto text-center">
                  <img
                    src={imgSrc}
                    alt={`Slide ${idx + 1}`}
                    className="w-full border border-gray-300 shadow"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>


        <p className="text-black text-base sm:text-lg md:text-xl leading-relaxed mt-8 md:mt-12">
          AngelWatch is not just another training course. It's the only
          emergency certification system in the country that is copyrighted,
          trademarked, and patented—designed specifically to preserve the
          integrity of our protocols and ensure the highest standard of
          protection. Unlike traditional safety courses that rely on passive
          video learning, AngelWatch places educators and staff into interactive
          emergency scenarios that require them to respond and pass tests in
          order to be certified. The platform also manages documentation,
          alerts, recertification timelines, and compliance tracking—all from
          one dashboard.
        </p>
      </div>

      {/* Certification Details Section */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-16 xl:gap-24">
          <div className="w-full lg:w-1/2 order-2 lg:order-1">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 leading-tight mt-4">
              At the AngelWatch Foundation, we take your safety so seriously—we’re giving you what others charge thousands for, absolutely free.
            </h2>
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed mt-4">
              When you enroll in the AngelWatch Certification Program, you're not just meeting training requirements—you’re receiving the tools, systems, and oversight your center needs to stay compliant, protect your staff, and safeguard every child in your care.
            </p>
            <button
              onClick={handleGoToContactUs}
              className="bg-[#F0AA00] w-[250px] text-white font-semibold py-3 px-8 rounded-full hover:bg-yellow-600 transition mt-6 w-full sm:w-auto"
            >
              Apply Here For Full Grants →
            </button>
          </div>

          <div className="w-full lg:w-1/2 order-1 lg:order-2">
            <img
              src={protectTraining}
              alt="Kids learning"
              className="rounded-tl-[50px] rounded-br-[50px] md:rounded-tl-[100px] md:rounded-br-[100px] shadow-lg w-full"
            />
          </div>
        </div>
      </div>
      {/* Highlighted Section 3 */}
      <div className="lg:p-[40px] p-4 mt-[30px] mb-[50px] bg-[#FCF7EE] rounded text-sm text-black">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12 space-y-6">
          <div>
            <h3
              className="font-semibold text-black"
              style={{ fontFamily: "Fredoka", fontSize: "24px" }}
            >
              The AngelWatch Emergency Management & Certification System
            </h3>
            <p className="text-base sm:text-lg lg:text-xl leading-relaxed mt-3">
              The nation’s most complete emergency readiness, compliance, and staff training platform for schools and childcare centers.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-4">
            <div className="space-y-6">
              <h4 className="text-xl sm:text-2xl font-semibold">Included Certification Courses</h4>

              <div className="space-y-5">
                <div>
                  <h5 className="font-semibold text-lg sm:text-xl">
                    1. Active Threat &amp; Lockdown Procedures
                  </h5>
                  <ul className="list-disc pl-5 space-y-1 text-sm sm:text-base">
                    <li>Active Shooter – Internal and External</li>
                    <li>Lockdown – Internal and External</li>
                    <li>Threat recognition and pre-attack indicators</li>
                    <li>Immediate action drills: move, cover, communicate</li>
                    <li>Tactical movement with children</li>
                    <li>Room hardening and barricading</li>
                    <li>Safe-room selection and setup</li>
                    <li>Perimeter lockdown and entry denial</li>
                    <li>Law-enforcement coordination and handoff</li>
                  </ul>
                </div>

                <div>
                  <h5 className="font-semibold text-lg sm:text-xl">
                    2. Combative Parent / Guardian &amp; Intruder Response
                  </h5>
                  <ul className="list-disc pl-5 space-y-1 text-sm sm:text-base">
                    <li>De-escalation and safe-distance management</li>
                    <li>Intruder identification and visitor screening</li>
                    <li>Custody and restraining-order flagging</li>
                    <li>Access control and secure-release protocols</li>
                  </ul>
                </div>

                <div>
                  <h5 className="font-semibold text-lg sm:text-xl">
                    3. Shelter-in-Place &amp; Environmental Emergencies
                  </h5>
                  <ul className="list-disc pl-5 space-y-1 text-sm sm:text-base">
                    <li>Weather, hazmat, and area-threat sheltering</li>
                    <li>Classroom containment and air-seal procedures</li>
                    <li>Evacuation decision-making and route discipline</li>
                    <li>Child comfort and communication during extended shelter events</li>
                  </ul>
                </div>

                <div>
                  <h5 className="font-semibold text-lg sm:text-xl">
                    4. Access Control &amp; Crisis Communication
                  </h5>
                  <ul className="list-disc pl-5 space-y-1 text-sm sm:text-base">
                    <li>Visitor screening and entry-point management</li>
                    <li>Crisis communication and alert coordination</li>
                    <li>Staff roles, chain of command, and sweep assignments</li>
                    <li>Coordination with first responders</li>
                  </ul>
                </div>

                <div>
                  <h5 className="font-semibold text-lg sm:text-xl">
                    5. Emergency Management, Compliance &amp; Reporting
                  </h5>
                  <ul className="list-disc pl-5 space-y-1 text-sm sm:text-base">
                    <li>Post-incident documentation and debriefing</li>
                    <li>Compliance tracking and renewal scheduling</li>
                    <li>Uploading and managing staff records</li>
                    <li>Regulatory and licensing compliance</li>
                  </ul>
                </div>

                <div>
                  <h5 className="font-semibold text-lg sm:text-xl">
                    6. Real-World Simulation &amp; Evaluation
                  </h5>
                  <ul className="list-disc pl-5 space-y-1 text-sm sm:text-base">
                    <li>Scenario-based drills and timed simulations</li>
                    <li>Staff performance testing under stress</li>
                    <li>Personal and group safety</li>
                    <li>Certification issued only after procedural mastery is demonstrated</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div>
                <h4 className="text-xl sm:text-2xl font-semibold">System Tools and Program Value</h4>
                <ul className="list-disc pl-5 space-y-1 text-sm sm:text-base mt-3">
                  <li>State-Compliant Emergency Plan and SOP Manual – printable, audit-ready, and accepted in all 50 states</li>
                  <li>Patented Cloud-Based Management Dashboard – tracks all AngelWatch courses plus your state-mandated and continuing-education trainings</li>
                  <li>Automatic Alerts and Renewal Tracking – ensures no certification ever lapses</li>
                  <li>Unlimited Staff Access – all current and future employees included at no cost</li>
                  <li>Instant Audit Reports – one click generates complete state-ready documentation</li>
                  <li>Ongoing Support and Annual Updates – stays aligned with all evolving state requirements</li>
                  <li>Official AngelWatch Certification Seal – display in your lobby, website, and enrollment materials to show parents your center meets the nation’s highest safety standards</li>
                  <li>Equivalent Staffing Value – replaces a Compliance Director, Safety Manager, Training Coordinator, and Licensing Administrator; more than $200,000 in equivalent value for a fraction of the cost</li>
                  <li>Flexible Enrollment Options – available as a subscription-based program or through limited-availability grant funding that can reduce your center’s cost by thousands</li>
                  <li>Nationwide Recognition – meets or exceeds OCFS, DCF, DFPS, DHS, DCFS, and all 50-state compliance standards</li>
                </ul>
              </div>

              <div>
                <h4 className="text-xl sm:text-2xl font-semibold">At a Glance</h4>
                <ul className="list-disc pl-5 space-y-1 text-sm sm:text-base mt-3">
                  <li>Six Core Certification Courses</li>
                  <li>24/7 Cloud Access and Auto Alerts</li>
                  <li>One-Click Audit Reports</li>
                  <li>Fully State-Compliant</li>
                  <li>$200K+ Equivalent Value</li>
                  <li>Subscription or Grant Funding Available</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pt-14">

        <Package />
      </div>
      <Review ref={reviewRef} reviews={reviews} />

      <Footer />
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <iframe className=" w-full h-[400px]" src="https://www.youtube.com/embed/qqgfMU7nmFc?si=vZS1I4U8YeJo2QSm" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </Modal>
      <PromoPopup isOpen={showPopup} onClose={handleClosePopup} />
    </div>
  );
}
